import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';

@Component({
  selector: 'app-dropdown',
  standalone: true,
  imports: [CommonModule, ClickOutsideDirective],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.scss',
})
export class DropdownComponent {
  dropdownOpen: boolean = false;
  @Input() value: string = '';
  @Input() label = '';
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() title = '';
  @Input() items = [];
  @Input() error = '';
  @Output() selectedValue = new EventEmitter<any>();
  ngOnInit(){
    if(this.value){
      this.setItem(this.value);
    }
  }
  open = () => {
    if(this.disabled){return}
    this.dropdownOpen = true;
  };
  close = () => {
    this.dropdownOpen = false;
  };
  setItem = (item: string) => {
    this.value = item;
    if (!this.title) {
      this.selectedValue.emit(item);
    } else {
      this.selectedValue.emit({ title: this.title, value: item });
    }
    this.close();
  };
}
